import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import "../../../style/icon/tabler-icons/webfont/tabler-icons.css";
import { setExpandMenu, setMobileSidebar } from "../../../store/slices/sidebar.slice";
import { useDispatch, useSelector } from "react-redux";
import {
} from "../../../store/slices/theme.slice";
import { SidebarDataTest, filterMenuBySubStatus } from "../../../core/data/json/sidebarMenu";
import { setDataLayout } from "../../../store/slices/theme.slice";
import { RootState } from "../../../store/store";
import { useTranslation } from "react-i18next";
import { PermissionType } from "../../../types/user.types";
import { all_routes } from "../../../router/all_routes";
import { useApprovalCounts } from "../../../hooks/useApprovalCounts";
const Sidebar = () => {
  const location = useLocation();
  const {user, sub} = useSelector((state:RootState)=>state.auth)
  
  // const {expandMenu} = useSelector((state:RootState) => state.sidebar)
  const {mobileSidebar} = useSelector((state:RootState) => state.sidebar)
  const dispatch = useDispatch();
  const [subOpen, setSubopen] = useState<any>("Employees");
  const [subsidebar, setSubsidebar] = useState("");

  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const isMobileView = window.matchMedia("(max-width: 767.98px)").matches;

      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node) &&
        mobileSidebar && // mobileSidebar true ise (yani mobil menü açıksa)
        isMobileView
      ) {
        dispatch(setMobileSidebar(false)); // Mobil sidebar'ı kapat
      }
    };

    // Sadece mobileSidebar true ise (yani mobil kenar çubuğu açıkken) event listener ekle.
    if (mobileSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileSidebar, dispatch]); // Bağımlılık olarak mobileSidebar kullan

  // const toggleSidebar = (title: any) => {
  //   localStorage.setItem("menuOpened", title);
  //   if (title === subOpen) {
  //     setSubopen("");
  //   } else {
  //     setSubopen(title);
  //   }
  // };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const handleLayoutChange = (layout: string) => {
    dispatch(setDataLayout(layout));
  };

  const handleClick = (label: any, themeSetting: any, layout: any) => {
    
    // toggleSidebar(label);
    if (themeSetting) {
      handleLayoutChange(layout);
    }
  };

  const getLayoutClass = (label: any) => {
    switch (label) {
      case "Default":
        return "default_layout";
      case "Mini":
        return "mini_layout";
      case "Box":
        return "boxed_layout";
      case "Dark":
        return "dark_data_theme";
      case "RTL":
        return "rtl";
      default:
        return "";
    }
  };

  const { t } = useTranslation();
  // Onaylar menüsündeki bekleyen onay rozeti (admin/yönetici için 60 sn'de bir yenilenir)
  const { total: pendingApprovalTotal } = useApprovalCounts();
  // useEffect(() => {
  //   const layoutPages = [
  //     "/layout-dark",
  //     "/layout-rtl",
  //     "/layout-mini",
  //     "/layout-box",
  //     "/layout-default",
  //   ];

  //   const isCurrentLayoutPage = layoutPages.some((path) =>
  //     location.pathname.includes(path)
  //   );
  //   const isPreviousLayoutPage =
  //     previousLocation &&
  //     layoutPages.some((path) => previousLocation.pathname.includes(path));


  // }, [location, previousLocation, dispatch]);

  useEffect(() => {
    const currentMenu = localStorage.getItem("menuOpened") || 'Employees';
    setSubopen(currentMenu);
    const submenus = document.querySelectorAll(".submenu");
    submenus.forEach((submenu) => {
      const listItems = submenu.querySelectorAll("li");
      submenu.classList.remove("active");
      listItems.forEach((item) => {
        if (item.classList.contains("active")) {
          submenu.classList.add("active");
          return;
        }
      });
    });
  }, [location.pathname]);


  const onMouseEnter = () => {
    const isMobileView = window.matchMedia("(max-width: 767.98px)").matches;
    if (!isMobileView) {
      const scrollPosition = window.scrollY;
      dispatch(setExpandMenu(true)); // Masaüstü için expandMenu kullanılabilir
      setTimeout(() => window.scrollTo(0, scrollPosition), 0);
    }
  };

  const onMouseLeave = () => {
    const isMobileView = window.matchMedia("(max-width: 767.98px)").matches;
    if (!isMobileView) {
      const scrollPosition = window.scrollY;
      dispatch(setExpandMenu(false)); // Masaüstü için expandMenu kullanılabilir
      setTimeout(() => window.scrollTo(0, scrollPosition), 0);
    }
  };
  return (
    <>
      <div
        ref={sidebarRef}
        className={`sidebar ${mobileSidebar ? "mobile-sidebar-visible" : ""}`} // Mobil görünürlük için bir sınıf ekleyebilirsin (CSS'de tanımlanmalı)
        id="sidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{zIndex: 1000}}
      >
  <div className="sidebar-logo" style={{
    top: 0,
    zIndex: 1001,
    backgroundColor: 'inherit',
    paddingTop: '8px',
    paddingBottom: '15px',
    margin: 0
  }}>
    <Link to="routes.index" className="logo" style={{width: '130px'}}>
      <ImageWithBasePath src="assets/img/dinox-light.png" alt="Logo" />
    </Link>
    <Link to="routes.index" className="logo-small">
      <ImageWithBasePath src="assets/img/normal.png" alt="Logo" />
    </Link>
    <Link to="routes.index" className="dark-logo">
      <ImageWithBasePath src="assets/img/dinox-dark.png" alt="Logo" />
    </Link>
  </div>
  {/* <div className="modern-profile p-3 pb-0">
    <div className="text-center rounded bg-light p-3 mb-4 user-profile">
      <div className="avatar avatar-lg online mb-3">
        <ImageWithBasePath
          src="assets/img/profiles/avatar-02.jpg"
          alt="Img"
          className="img-fluid rounded-circle"
        />
      </div>
      <h6 className="fs-12 fw-normal mb-1">Adrian Herman</h6>
      <p className="fs-10">System Admin</p>
    </div>
    <div className="sidebar-nav mb-3">
      <ul
        className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
        role="tablist"
      >
        <li className="nav-item">
          <Link className="nav-link active border-0" to="#">Menu</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link border-0" to="#">Chats</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link border-0" to="#">Inbox</Link>
        </li>
      </ul>
    </div>
  </div> */}
  {/* <div className="sidebar-header p-3 pb-0 pt-2">
    <div
      className="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center"
    >
      <div className="avatar avatar-md onlin">
        <ImageWithBasePath
          src="assets/img/profiles/avatar-02.jpg"
          alt="Img"
          className="img-fluid rounded-circle"
        />
      </div>
      <div className="text-start sidebar-profile-info ms-2">
        <h6 className="fs-12 fw-normal mb-1">Adrian Herman</h6>
        <p className="fs-10">System Admin</p>
      </div>
    </div>
    <div className="input-group input-group-flat d-inline-flex mb-4">
      <span className="input-icon-addon">
        <i className="ti ti-search"></i>
      </span>
      <input type="text" className="form-control" placeholder="Search in HRMS" />
      <span className="input-group-text">
        <kbd>CTRL + / </kbd>
      </span>
    </div>
    <div
      className="d-flex align-items-center justify-content-between menu-item mb-3"
    >
      <div className="me-3">
        <Link to="#" className="btn btn-menubar position-relative">
          <i className="ti ti-shopping-bag"></i>
          <span className="badge bg-success rounded-pill d-flex align-items-center justify-content-center header-badge"
            >5</span>
        </Link>
      </div>
      <div className="me-3">
        <Link to="#" className="btn btn-menubar">
          <i className="ti ti-layout-grid-remove"></i>
        </Link>
      </div>
      <div className="me-3">
        <Link to="#" className="btn btn-menubar position-relative">
          <i className="ti ti-brand-hipchat"></i>
          <span
            className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge"
            >5</span>
        </Link>
      </div>
      <div className="me-3 notification-item">
        <Link to="#" className="btn btn-menubar position-relative me-1">
          <i className="ti ti-bell"></i>
          <span className="notification-status-dot"></span>
        </Link>
      </div>
      <div className="me-0">
        <Link to="#" className="btn btn-menubar">
          <i className="ti ti-message"></i>
        </Link>
      </div>
    </div>
  </div> */}
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
              {filterMenuBySubStatus(SidebarDataTest, sub, user)?.filter((mainLabel) => {
                // Eğer mainLabel'da role varsa ve kullanıcı rolüne uymuyorsa gizle
                if (mainLabel.role) {
                  // Kullanıcının permissions array'i var mı kontrol et
                  if (!user?.permissions || user.permissions.length === 0) {
                    return false;
                  }
                  // Permission kontrolü - hem enum hem string karşılaştırması
                  const hasPermission = mainLabel.role.some((role: PermissionType) => {
                    return user.permissions?.some((userPerm: PermissionType | string) => {
                      // Enum değeri veya string değeri olarak karşılaştır
                      return userPerm === role || userPerm === String(role);
                    });
                  });
                  if (!hasPermission) {
                    return false;
                  }
                }
                return true;
              }).             
                map((mainLabel, index) => (
                <React.Fragment key={`main-${index}`}>
                    <li className="menu-title">
                        <span>{t(mainLabel?.tittle)}</span>
                    </li>
                    <li>
                    <ul>
                    {mainLabel?.submenuItems
                    ?.filter((title: any) => {
                      // Eğer title'da role varsa ve kullanıcı rolüne uymuyorsa gizle
                      if (title?.role) {
                        // Kullanıcının permissions array'i var mı kontrol et
                        if (!user?.permissions || user.permissions.length === 0) {
                          return false;
                        }
                        // Permission kontrolü - hem enum hem string karşılaştırması
                        const hasPermission = title.role.some((role: PermissionType) => {
                          return user.permissions?.some((userPerm: PermissionType | string) => {
                            // Enum değeri veya string değeri olarak karşılaştır
                            return userPerm === role || userPerm === String(role);
                          });
                        });
                        if (!hasPermission) {
                          return false;
                        }
                      }
                      return true;
                    })
                    .map((title: any, i: any) => {
                      let link_array: any = [];
                      if ("submenuItems" in title) {
                        title.submenuItems?.forEach((link: any) => {
                          // Eğer link'in role'u varsa ve kullanıcı rolüne uymuyorsa ekleme
                          if (!link?.role) {
                            link_array.push(link?.link);
                          } else {
                            // Permission kontrolü - hem enum hem string karşılaştırması
                            const hasPermission = link.role.some((role: PermissionType) => {
                              return user?.permissions?.some((userPerm: PermissionType | string) => {
                                return userPerm === role || userPerm === String(role);
                              });
                            });
                            if (hasPermission) {
                              link_array.push(link?.link);
                              if (link?.submenu && "submenuItems" in link) {
                                link.submenuItems?.forEach((item: any) => {
                                  const itemHasPermission = !item?.role || item.role.some((role: PermissionType) => {
                                    return user?.permissions?.some((userPerm: PermissionType | string) => {
                                      return userPerm === role || userPerm === String(role);
                                    });
                                  });
                                  if (itemHasPermission) {
                                    link_array.push(item?.link);
                                  }
                                });
                              }
                            }
                          }
                        });
                      }
                        title.links = link_array;

                        return (
                            <li className="submenu" key={`title-${i}`}>
                            <Link
                                data-tour={title?.dataTour}
                                to={title?.submenu ? "#" : title?.link}
                                onClick={() =>
                                handleClick(
                                    title?.label,
                                    title?.themeSetting,
                                    getLayoutClass(title?.label)
                                )
                                }
                                className={`${
                                subOpen === title?.label ? "subdrop" : ""
                                } ${
                                title?.links?.includes(location.pathname) ? "active" : ""
                                } ${
                                title?.submenuItems
                                    ?.map((link: any) => link?.link)
                                    .includes(location.pathname) ||
                                title?.link === location.pathname
                                    ? "active"
                                    : ""
                                }`}
                            >
                                <i className={`ti ti-${title.icon}`}></i>
                                <span>{t(title?.label)}</span>
                                {title?.link === all_routes.approvals && pendingApprovalTotal > 0 && (
                                <span className="badge bg-danger rounded-pill fs-10 fw-medium text-white ms-auto">
                                    {pendingApprovalTotal > 99 ? "99+" : pendingApprovalTotal}
                                </span>
                                )}
                                {title?.dot && (
                                <span className="badge badge-danger fs-10 fw-medium text-white p-1">
                                    Hot
                                </span>
                                )}
                                <span className={title?.submenu ? "menu-arrow" : ""} />
                            </Link>
                            {title?.submenu !== false && subOpen === title?.label && (
                                <ul
                                style={{
                                    display: subOpen === title?.label ? "block" : "none",
                                }}
                                >
                                {title?.submenuItems
                                  ?.filter(
                                    (item: any) => {
                                      if (!item?.role) return true;
                                      // Permission kontrolü - hem enum hem string karşılaştırması
                                      return item.role.some((role: PermissionType) => {
                                        return user?.permissions?.some((userPerm: PermissionType | string) => {
                                          return userPerm === role || userPerm === String(role);
                                        });
                                      });
                                    }
                                  )
                                
                                .map((item: any, j: any) => (
                                    <li
                                    className={
                                        item?.submenuItems ? "submenu submenu-two" : ""
                                    }
                                    key={`item-${j}`}
                                    >
                                    <Link
                                        data-tour={item?.dataTour}
                                        to={ item?.submenu ? "#" :item?.link}
                                        className={`${
                                        item?.submenuItems
                                            ?.map((link: any) => link?.link)
                                            .includes(location.pathname) ||
                                        item?.link === location.pathname
                                            ? "active"
                                            : ""
                                        } ${
                                        subsidebar === item?.label ? "subdrop" : ""
                                        }`}
                                        onClick={() => {
                                        toggleSubsidebar(item?.label);
                                        }}
                                    >
                                        {item?.label}
                                        <span
                                        className={item?.submenu ? "menu-arrow" : ""}
                                        />
                                    </Link>
                                    {item?.submenuItems ? (
                                        <ul
                                        style={{
                                            display:
                                            subsidebar === item?.label ? "block" : "none",
                                        }}
                                        >
                                        {item?.submenuItems
                                          ?.filter(
                                            (items: any) => {
                                              if (!items?.role) return true;
                                              // Permission kontrolü - hem enum hem string karşılaştırması
                                              return items.role.some((role: PermissionType) => {
                                                return user?.permissions?.some((userPerm: PermissionType | string) => {
                                                  return userPerm === role || userPerm === String(role);
                                                });
                                              });
                                            }
                                          )
                                        
                                        .map((items: any, k: any) => (
                                            <li key={`submenu-item-${k}`}>
                                            <Link
                                                data-tour={items?.dataTour}
                                                to={items?.submenu ? "#" :items?.link}
                                                className={`${
                                                subsidebar === items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                } ${
                                                items?.submenuItems
                                                    ?.map((link: any) => link.link)
                                                    .includes(location.pathname) ||
                                                items?.link === location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}
                                            >
                                                {items?.label}
                                            </Link>
                                            </li>
                                        ))}
                                        </ul>
                                    ) : null}
                                    </li>
                                ))}
                                </ul>
                            )}
                            </li>
                        );
                        })}
                    </ul>
                    </li>
                </React.Fragment>
                ))}

              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
